export default "/images/vendor/flag-icon-css/flags/1x1/to.svg?aaa24511e1160314531ac9a771642a48";